import React from 'react';

const VMK_TEAL = '#179f9f';

const iconProps = {
  className: 'vmk-proposal-benefit-icon',
  width: 46,
  height: 46,
  viewBox: '0 0 48 48',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  role: 'img',
  'aria-hidden': true,
};

const s = {
  stroke: VMK_TEAL,
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const VmkBenefitEnergyIcon = () => (
  <svg {...iconProps}>
    <path
      d="M24 6.5C15.5 18.5 9.5 25 9.5 33a14.5 14.5 0 1 0 29 0c0-8-6-14.5-14.5-26.5z"
      {...s}
    />
    <path d="M18.5 30.5c2.5-4 7-5 10.5-2" {...s} />
    <path d="M21 27.5l-2.5 4" {...s} />
    <path d="M24 24.5l1.5 3.5" {...s} />
  </svg>
);

export const VmkBenefitComfortIcon = () => (
  <svg {...iconProps}>
    <path d="M7.5 22.5 24 9.5 40.5 22.5" {...s} />
    <path d="M11 21v19.5h26V21" {...s} />
    <path d="M17.5 40.5v-11h13v11" {...s} />
    <circle cx="19.5" cy="28.5" r="1.1" fill={VMK_TEAL} stroke="none" />
    <circle cx="28.5" cy="28.5" r="1.1" fill={VMK_TEAL} stroke="none" />
    <path d="M19.5 32.5q4.5 3.5 9 0" {...s} />
  </svg>
);

export const VmkBenefitValueIcon = () => (
  <svg {...iconProps}>
    <circle cx="16" cy="17" r="4" {...s} />
    <circle cx="32" cy="17" r="4" {...s} />
    <circle cx="24" cy="21" r="3.25" {...s} />
    <path d="M9.5 38c1.5-6 4.5-9 6.5-9s5 3 6.5 9" {...s} />
    <path d="M25.5 38c1-4.5 3-7 6.5-7s5.5 2.5 6.5 7" {...s} />
    <path d="M17 38c1-5 2.5-7.5 7-7.5s6 2.5 7 7.5" {...s} />
  </svg>
);

export const VmkBenefitMaintenanceIcon = () => (
  <svg {...iconProps}>
    <path d="M14 34 22.5 25.5" {...s} />
    <path d="M12.5 35.5 10 38" {...s} />
    <path d="M22 24.5a4.5 4.5 0 0 1 6.4-6.4l5.6 5.6a4.5 4.5 0 0 1-6.4 6.4z" {...s} />
    <path d="M34 14 25.5 22.5" {...s} />
    <path d="M35.5 12.5 38 10" {...s} />
    <path d="M26.5 22a4.5 4.5 0 0 1-6.4 6.4l-5.6-5.6A4.5 4.5 0 0 1 20.5 16.5" {...s} />
  </svg>
);

export const VmkBenefitSoundIcon = () => (
  <svg {...iconProps}>
    <rect x="9" y="12" width="17" height="24" rx="1.5" {...s} />
    <path d="M17.5 12v24" {...s} />
    <path d="M9 24h17" {...s} />
    <path d="M31 18c2.5 2 2.5 10 0 12" {...s} />
    <path d="M35 14.5c4 3.5 4 15.5 0 19" {...s} />
    <path d="M39 11c5.5 4.5 5.5 20.5 0 26" {...s} />
  </svg>
);

export const VmkBenefitSecurityIcon = () => (
  <svg {...iconProps}>
    <rect x="13" y="21" width="22" height="18" rx="2.5" {...s} />
    <path d="M17 21v-5a7 7 0 0 1 14 0v5" {...s} />
    <circle cx="24" cy="30" r="3" {...s} />
    <path d="M24 33v3.5" {...s} />
  </svg>
);

export const VMK_PROPOSAL_BENEFIT_ICONS = [
  VmkBenefitEnergyIcon,
  VmkBenefitComfortIcon,
  VmkBenefitValueIcon,
  VmkBenefitMaintenanceIcon,
  VmkBenefitSoundIcon,
  VmkBenefitSecurityIcon,
];

/** Teal check for specs list items */
export const VmkSpecsCheckIcon = () => (
  <svg
    className="vmk-specs-check-icon"
    width={14}
    height={14}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M7 12.5 10.5 16 17.5 8.5"
      stroke="#179f9f"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VmkProposalCircleCheckIcon = () => (
  <svg
    className="vmk-proposal-check-icon"
    width={18}
    height={18}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="1.75" />
    <path
      d="M8.25 12.25 10.75 14.75 16.25 8.75"
      stroke="#fff"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
